import { RoutePathsType } from "../types/routePaths";

export const RoutePaths: RoutePathsType = {
  NavBar: {
    primaryLinks: [
      {
        name: "Mobile",
        url: "/mobile",
        as: "dropdown",
        subMenu: [
          {
            title: "Smartphones",
            path: "/mobile/smartphones",
          },
          {
            title: "Tablets",
            path: "/mobile/tablets",
          },
          {
            title: "Smartwatch & Wearables",
            path: "/mobile/wearables",
          },
          {
            title: "Telco",
            path: "/mobile/telco",
          },
        ],
      },
      {
        name: "PC",
        url: "/pc",
        as: "dropdown",
        subMenu: [
          {
            title: "Laptops",
            path: "/pc/laptops",
          },
          {
            title: "Monitors, Input Devices & Accessories",
            path: "/pc/accessories",
          },
          {
            title: "PC Components",
            path: "/pc/components",
          },
          {
            title: "Storage",
            path: "/pc/storage",
          },
          {
            title: "Networking & Security",
            path: "/pc/networking",
          },
        ],
      },
      {
        name: "Lifestyle",
        url: "/lifestyle",
        as: "dropdown",
        subMenu: [
          {
            title: "Audio",
            path: "/lifestyle/audio",
          },
          {
            title: "Video",
            path: "/lifestyle/video",
          },
          {
            title: "Photography",
            path: "/lifestyle/photography",
          },
          {
            title: "Smart Home",
            path: "/lifestyle/home",
          },
          {
            title: "AI",
            path: "/lifestyle/ai",
          },
          {
            title: "Cars",
            path: "/lifestyle/cars",
          },
          {
            title: "Apps & Software",
            path: "/lifestyle/apps",
          },
        ],
      },
      {
        name: "Entertainment",
        url: "/entertainment",
        as: "dropdown",
        subMenu: [
          {
            title: "Gaming & Culture",
            path: "/entertainment/gaming",
          },
          {
            title: "TV & Movies",
            path: "/entertainment/tv-movies",
          },
        ],
      },
      {
        name: "Guides",
        url: "/guides",
        as: "dropdown",
        subMenu: [
          {
            title: "How To",
            path: "/guides/how-to",
          },
          {
            title: "Tips",
            path: "/tag/tips-and-tricks",
          },
        ],
      },
      {
        name: "Deals",
        url: "/deals",
      },
    ],
    utilityLinks: [
      {
        id: "magazineIssues", // allow overwrite of name and url from data
        name: "Subscribe",
        url: "https://subscribe.sph.com.sg/package/subscribe-her-world-singapore/",
        as: "button",
        variant: "primary",
        target: "_blank",
      },
    ],
    searchBarLink: {
      name: "Search",
      url: "/search",
    },
    mobileUtilityLinks: {
      // login: {
      //   name: "Login",
      //   url: "/",
      // },
    },
  },
  Footer: [
    {
      text: "About Us",
      url: "/about-us",
    },
    /*{
      text: "Awards & Accolades",
      url: "/awards-and-accolades",
      target: "_blank",
    },*/
    {
      text: "Contact Us & Feedback",
      url: "/contact-us",
      target: "_blank",
    },
    {
      text: "Advertise with Us",
      url: "https://www.sph.com.sg/advertising-solutions/",
      target: "_blank",
    },
    {
      text: "Terms and Conditions",
      url: "https://www.sph.com.sg/tnc/website/",
      target: "_blank",
    },
    {
      text: "Personal Data Protection Notice",
      url: "https://www.sph.com.sg/tnc/pdpa/",
      target: "_blank",
    },
  ],
  MegaMenu: [
    {
      text: "MOBILE",
      url: "/mobile",
      placement: "left",
      subMenu: [
        {
          text: "Smartphones",
          url: "/mobile/smartphones",
        },
        {
          text: "Tablets",
          url: "/mobile/tablets",
        },
        {
          text: "Smartwatch & Wearables",
          url: "/mobile/wearables",
        },
        {
          text: "Telco",
          url: "/mobile/telco",
        },
      ],
    },
    {
      text: "PC",
      url: "/pc",
      placement: "left",
      subMenu: [
        {
          text: "Laptops",
          url: "/pc/laptops",
        },
        {
          text: "Accessories",
          url: "/pc/accessories",
        },
        {
          text: "PC Components",
          url: "/pc/components",
        },
        {
          text: "Storage",
          url: "/pc/storage",
        },
        {
          text: "Networking & Security",
          url: "/pc/networking",
        },
      ],
    },
    {
      text: "LIFESTYLE",
      url: "/lifestyle",
      placement: "left",
      subMenu: [
        {
          text: "Audio",
          url: "/lifestyle/audio",
        },
        {
          text: "Video",
          url: "/lifestyle/video",
        },
        {
          text: "Photography",
          url: "/lifestyle/photography",
        },
        {
          text: "Smart Home",
          url: "/lifestyle/home",
        },
        {
          text: "AI",
          url: "/lifestyle/ai",
        },
        {
          text: "Cars",
          url: "/lifestyle/cars",
        },
        {
          text: "Apps & Software",
          url: "/lifestyle/apps",
        },
      ],
    },
    {
      text: "ENTERTAINMENT",
      url: "/entertainment",
      placement: "left",
      subMenu: [
        {
          text: "Gaming & Culture",
          url: "/entertainment/gaming",
        },
        {
          text: "TV & Movies",
          url: "/entertainment/tv-movies",
        },
      ],
    },
    {
      text: "GUIDES",
      url: "/guides",
      placement: "left",
      subMenu: [
        {
          text: "How To",
          url: "/guides/how-to",
        },
        {
          text: "Tips",
          url: "/tag/tips-and-tricks",
        },
      ],
    },
    {
      text: "DEALS",
      url: "/deals",
      placement: "left",
      subMenu: [],
    },
    {
      text: "EDITOR'S PICKS",
      url: "/tag/editors-picks",
      placement: "left",
      subMenu: [],
    },
    {
      text: "FORUM",
      url: "https://forums.hardwarezone.com.sg/",
      placement: "left",
      subMenu: [],
    },
    {
      text: "TECH SHOW PORTAL",
      url: "/tech-show",
      placement: "left",
      subMenu: [],
    },
  ],
};
